import script from "./CourseAuthor.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseAuthor.vue?vue&type=script&setup=true&lang=js"

import "./CourseAuthor.vue?vue&type=style&index=0&id=55dc2114&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55dc2114"]])

export default __exports__